/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Invitecollaborator1Inputs */

const en_settings_collaborators_invitecollaborator1 = /** @type {(inputs: Settings_Collaborators_Invitecollaborator1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite Collaborator`)
};

/**
* | output |
* | --- |
* | "Invite Collaborator" |
*
* @param {Settings_Collaborators_Invitecollaborator1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_invitecollaborator1 = /** @type {((inputs?: Settings_Collaborators_Invitecollaborator1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Invitecollaborator1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_invitecollaborator1(inputs)
});
export { settings_collaborators_invitecollaborator1 as "settings_collaborators_inviteCollaborator" }